import {Box, Container, Flex, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {SelectDay} from 'components/shared/select-day';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IRestaurant} from 'types';

interface Props {
  provider: IRestaurant;
  t: (term: TranslationKeys) => string;
}

export const Information: FC<Props> = ({provider, t}) => {
  const {name, price_level, logo_thumbnail, tags, branch_addresses, schedules} = provider;
  return (
    <Box>
      <IconBlock heading={name} icon={logo_thumbnail}>
        <Text fontSize="16px" fontWeight={500}>
          {tags}
        </Text>
        <Flex alignItems="center">
          {Array.from({length: price_level as number}, (_, i) => (
            <Text key={i}>$</Text>
          ))}
        </Flex>
      </IconBlock>
      <Box mt="30px">
        <Text fontSize="16px" fontWeight={600} mb="15px">
          {t('ADDRESSES_IN_CHISINAU')}
        </Text>
        <IconBlock heading={name} icon="/my-location-icon.svg">
          <Flex justifyContent="center" flexDirection="column" w="100%">
            {branch_addresses.map((address, index) => (
              <Text key={index} fontSize="16px" fontWeight={500}>
                {address.address.city} {address.address_name}
              </Text>
            ))}
          </Flex>
        </IconBlock>
      </Box>
      <Box mt="30px">
        <Text fontSize="16px" fontWeight={600} mb="15px">
          {t('WORK_PROGRAM_TODAY')}
        </Text>
        <Container variant="white-block">
          <SelectDay schedules={schedules} t={t} />
        </Container>
      </Box>
    </Box>
  );
};
